module.exports = "/_next/static/images/Personalization-sm@2x-dd4b1d97a5bde1b9fa30401efdce1cba.webp";